module.exports = __webpack_public_path__ + "img/bg_score_03.8335bdc5.jpg";